(function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.hc-section-toggle');
    if (toggle) {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      return;
    }

    var collapse = e.target.closest('.hc-sidebar-collapse');
    if (collapse) {
      var layout = collapse.closest('.hc-layout');
      if (layout) layout.classList.add('hc-sidebar-collapsed');
      return;
    }

    var expand = e.target.closest('.hc-sidebar-expand');
    if (expand) {
      var layout = expand.closest('.hc-layout');
      if (layout) layout.classList.remove('hc-sidebar-collapsed');
      return;
    }

    var helpful = e.target.closest('.hc-pill-btn[data-helpful]');
    if (helpful) {
      var container = helpful.closest('.hc-helpful');
      if (container) container.innerHTML = '<span>Thanks for your feedback.</span>';
    }
  });

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // Walk up from an element and force overflow: visible on any ancestor that
  // has overflow hidden/clip/auto/scroll — those break position: sticky on descendants.
  // Theme wrappers (main#MainContent, .shopify-section, etc.) commonly do this.
  function fixStickyAncestors(el) {
    if (!el) return;
    var node = el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var cs = window.getComputedStyle(node);
      if (/(hidden|clip|auto|scroll)/.test(cs.overflow + ' ' + cs.overflowX + ' ' + cs.overflowY)) {
        node.style.setProperty('overflow', 'visible', 'important');
        node.style.setProperty('overflow-x', 'visible', 'important');
        node.style.setProperty('overflow-y', 'visible', 'important');
      }
      node = node.parentElement;
    }
  }

  // Nuclear-option fix for themes that reset list-style on ul/ol via highly-specific
  // CSS. Inline styles with !important beat any external stylesheet rule.
  function forceArticleListStyles() {
    var body = document.querySelector('.hc-article-body');
    if (!body) return;
    body.querySelectorAll('ul').forEach(function (ul) {
      var type = ul.closest('ul ul') ? 'circle' : 'disc';
      ul.style.setProperty('list-style', type + ' outside', 'important');
      ul.style.setProperty('list-style-type', type, 'important');
      ul.style.setProperty('list-style-position', 'outside', 'important');
      ul.style.setProperty('padding-left', '24px', 'important');
      ul.style.setProperty('margin', '0 0 20px', 'important');
    });
    body.querySelectorAll('ol').forEach(function (ol) {
      var type = ol.closest('ol ol') ? 'lower-alpha' : 'decimal';
      ol.style.setProperty('list-style', type + ' outside', 'important');
      ol.style.setProperty('list-style-type', type, 'important');
      ol.style.setProperty('list-style-position', 'outside', 'important');
      ol.style.setProperty('padding-left', '24px', 'important');
      ol.style.setProperty('margin', '0 0 20px', 'important');
    });
    body.querySelectorAll('li').forEach(function (li) {
      li.style.setProperty('display', 'list-item', 'important');
      li.style.setProperty('margin-bottom', '10px', 'important');
      li.style.setProperty('padding-left', '0', 'important');
      li.style.setProperty('background', 'none', 'important');
    });
  }

  // Article handles that should always load with the "All articles" sidebar
  // collapsed. Visitors can still click "» All articles" to open it.
  var COLLAPSED_BY_DEFAULT = ['how-to-use-one-good-card'];

  onReady(function () {
    var layout = document.querySelector('.hc-layout');

    function openAnchoredFaq() {
      if (!window.location.hash) return;

      var target;

      try {
        target = document.querySelector(window.location.hash);
      } catch (error) {
        return;
      }

      if (!target || target.tagName !== 'DETAILS') return;

      target.open = true;

      window.setTimeout(function () {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);
    }

    openAnchoredFaq();
    window.addEventListener('hashchange', openAnchoredFaq);

    // Collapse the sidebar by default on mobile
    if (layout && window.matchMedia('(max-width: 960px)').matches) {
      layout.classList.add('hc-sidebar-collapsed');
    }

    // Collapse by default for specific articles (matched on the URL handle)
    if (layout) {
      var path = window.location.pathname.replace(/\/+$/, '');
      var handle = path.substring(path.lastIndexOf('/') + 1);
      if (COLLAPSED_BY_DEFAULT.indexOf(handle) !== -1) {
        layout.classList.add('hc-sidebar-collapsed');
      }
    }

    forceArticleListStyles();

    // Auto-generate Table of Contents from H2 headings in the article body
    var col = document.querySelector('.hc-article-col');
    var tocList = document.querySelector('.hc-toc-list');
    var tocEl = document.querySelector('.hc-toc');
    var grid = document.querySelector('.hc-main-grid');
    if (!col || !tocList || !grid) return;

    var headings = col.querySelectorAll('.hc-article-body h2, .hc-faq h2');
    if (headings.length === 0) {
      if (tocEl) tocEl.remove();
      return;
    }

    grid.classList.add('hc-has-toc');

    // Desktop only: force overflow: visible on ancestors so sticky works
    if (tocEl && window.matchMedia('(min-width: 1101px)').matches) {
      fixStickyAncestors(tocEl);
    }

    var anchors = [];
    Array.prototype.forEach.call(headings, function (h, i) {
      if (!h.id) {
        var slug = (h.textContent || '').toLowerCase().trim()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        h.id = slug || 'section-' + (i + 1);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.setAttribute('data-target', h.id);
      li.appendChild(a);
      tocList.appendChild(li);
      anchors.push(a);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            anchors.forEach(function (a) { a.classList.remove('active'); });
            var active = tocList.querySelector('a[data-target="' + entry.target.id + '"]');
            if (active) active.classList.add('active');
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      Array.prototype.forEach.call(headings, function (h) { observer.observe(h); });
    }

    if (tocEl && tocEl.tagName === 'DETAILS' && window.matchMedia('(max-width: 1100px)').matches) {
      tocEl.removeAttribute('open');
    }
  });
})();
